import React from "react";

function ShowCustomDisposition(props) {

	return (
		<div>
			{props.dispositions && Object.keys(props.dispositions).length ? (
				Object.keys(props.dispositions).map((key, index) => (
					<div className="body" key={key}>
						<p className="name" style={{ margin: "10px 0", color: " #686D88" }} margin="2px">
							{key}
						</p>
						<p className="value" style={{ margin: "10px 0" }} margin="2px">
							<b>{props.dispositions[key]}</b>
						</p>
					</div>
				))
			) : (
				<div className="body">No Data</div>
			)}
		</div>
	);
}



export default ShowCustomDisposition;
